import React, { useState, useEffect } from "react";

export function useTimer() {
    const [time, setTime] = useState(null)
    function setTimeFunc(time) {
        setTime(time)
    }
    useEffect(() => {
        if (time <= 0) {
            return;
        }
        const timer = setInterval(() => {
            setTime((prev) => prev - 1)
        }, 1000)
        return () => {
            clearInterval(timer)
        }
    }, [time]);
    return [time, setTimeFunc]
}
